module.exports = __webpack_public_path__ + "img/dp158_05.ca1324c1.jpg";